if (!window.Eurus.loadedScript.has('product-bundle.js')) {
window.Eurus.loadedScript.add('product-bundle.js');

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.data('xProductBundle', (
      sectionId,
      minimumItems,
      shopCurrency,
      discountType,
      discountValue,
      applyDiscountOncePerOrder,
      bundleTiers = [],
      nudgeStrings = {}
    ) => ({
      products: "",
      productsBundle: [],
      loading: false,
      addToCartButton: "",
      totalPrice: 0,
      errorMessage: false,
      showBundleContent: false,
      totalDiscount: 0,
      amountPrice: 0,
      initBundle(el) {
        this.addToCartButton = el.querySelector(".button-atc");
        this.handleProductsBundle();
      },
      nextTierBundleNudge() {
        const count = this.productsBundle.length;
        if (!bundleTiers || !bundleTiers.length || count < 0) return null;
        const sorted = [...bundleTiers].sort((a, b) => Number(a.min) - Number(b.min));
        const next = sorted.find((t) => Number(t.min) > count);
        if (!next) return null;
        return {
          min: Number(next.min),
          discount: String(next.discount || ''),
          image: next.image ? String(next.image) : '',
          needed: Number(next.min) - count
        };
      },
      nextTierBundleNudgeText() {
        const next = this.nextTierBundleNudge();
        if (!next) return '';
        const ns = nudgeStrings && typeof nudgeStrings === 'object' ? nudgeStrings : {};
        const one = ns.nudgeOne || '';
        const other = ns.nudgeOther || '';
        const label = ns.productLabel || '';
        const tpl = next.needed === 1 ? one : other;
        return tpl
          .replace(/\{count\}/g, String(next.needed))
          .replace(/\{product_label\}/g, label)
          .replace(/\{discount\}/g, next.discount);
      },
      getMinimumItemsForBundle() {
        if (Array.isArray(bundleTiers) && bundleTiers.length > 0) {
          const mins = bundleTiers.map((t) => Number(t.min)).filter((m) => Number.isFinite(m) && m > 0);
          if (mins.length) return Math.min.apply(null, mins);
        }
        return Number(minimumItems) || 0;
      },
      getActiveTierDiscountNumeric(count) {
        if (Array.isArray(bundleTiers) && bundleTiers.length > 0) {
          const sortedDesc = [...bundleTiers].sort((a, b) => Number(b.min) - Number(a.min));
          const tier = sortedDesc.find((t) => count >= Number(t.min));
          if (tier != null && tier.value !== undefined && tier.value !== null && tier.value !== '') {
            const v = Number(tier.value);
            if (Number.isFinite(v)) return v;
          }
          return NaN;
        }
        const v = Number(discountValue);
        return Number.isFinite(v) ? v : NaN;
      },
      computeTierPricing(total, count, discountNum) {
        if (!Number.isFinite(discountNum) || discountNum <= 0) return null;
        if (discountType == 'percentage') {
          if (discountNum >= 100) return null;
          const discountedTotal = Math.ceil(total - (total * discountNum) / 100);
          const savings = total - discountedTotal;
          return { discountedTotal, savings };
        }
        if (discountType == 'amount') {
          const amt = Number.parseFloat(String(discountNum));
          if (!Number.isFinite(amt) || amt <= 0) return null;
          const off = applyDiscountOncePerOrder
            ? amt * Shopify.currency.rate * 100
            : count * amt * Shopify.currency.rate * 100;
          const discountedTotal = total - off;
          const savings = total - discountedTotal;
          return { discountedTotal, savings };
        }
        return null;
      },
      updateItems(productsBundle) {
        const count = productsBundle.length;
        const total = productsBundle.reduce((sum, item) => sum + (item.price || 0), 0);

        const clearLineDisplayPrices = () => {
          productsBundle.forEach((item) => {
            if (Object.prototype.hasOwnProperty.call(item, 'bundleDisplayPriceCents')) {
              delete item.bundleDisplayPriceCents;
            }
          });
        };

        if (count < this.getMinimumItemsForBundle() || total <= 0) {
          clearLineDisplayPrices();
          return;
        }

        const discountNum = this.getActiveTierDiscountNumeric(count);
        if (!Number.isFinite(discountNum) || discountNum <= 0) {
          clearLineDisplayPrices();
          return;
        }

        const pricing = this.computeTierPricing(total, count, discountNum);
        if (!pricing || pricing.discountedTotal <= 0) {
          clearLineDisplayPrices();
          return;
        }

        if (discountType == 'amount' && !applyDiscountOncePerOrder) {
          const flatOffCents = Math.round(Number.parseFloat(String(discountNum)) * Shopify.currency.rate * 100);
          productsBundle.forEach((item) => {
            item.bundleDisplayPriceCents = Math.max(0, (item.price || 0) - flatOffCents);
          });
          return;
        }

        productsBundle.forEach((item) => {
          const p = item.price || 0;
          item.bundleDisplayPriceCents = total > 0 ? Math.round((pricing.discountedTotal * p) / total) : p;
        });

        const sumLines = productsBundle.reduce((s, item) => s + (item.bundleDisplayPriceCents || 0), 0);
        const drift = pricing.discountedTotal - sumLines;
        if (drift !== 0 && productsBundle.length > 0) {
          const last = productsBundle[productsBundle.length - 1];
          last.bundleDisplayPriceCents = Math.max(0, (last.bundleDisplayPriceCents || 0) + drift);
        }
      },
      updateTotal(productsBundle) {
        const total = productsBundle.reduce((sum, item) => sum + item.price, 0);
        const count = productsBundle.length;
        const minRequired = this.getMinimumItemsForBundle();

        if (count >= minRequired) {
          this.addToCartButton.removeAttribute('disabled');
          const discountNum = this.getActiveTierDiscountNumeric(count);

          if (Number.isFinite(discountNum) && discountNum > 0) {
            const pricing = this.computeTierPricing(total, count, discountNum);
            if (pricing && pricing.discountedTotal > 0) {
              this.amountPrice = this.formatMoney(pricing.savings, shopCurrency);
              this.totalDiscount = this.formatMoney(pricing.discountedTotal, shopCurrency);
            } else if (pricing) {
              this.amountPrice = this.formatMoney(0, shopCurrency);
              this.totalDiscount = this.formatMoney(total, shopCurrency);
            } else {
              this.amountPrice = 0;
              this.totalDiscount = 0;
            }
          } else {
            this.amountPrice = 0;
            this.totalDiscount = 0;
          }
        } else {
          this.totalDiscount = 0;
          this.addToCartButton.setAttribute('disabled', 'disabled');
        }
        this.totalPrice = this.formatMoney(total, shopCurrency);
      },
      updateTierTexts() {
        const next = this.nextTierBundleNudge();

        const footerTextCount = this.$el.closest("#products-bundle").querySelector('.bundler-footer-text-count');
        const footerTextFinal = this.$el.closest("#products-bundle").querySelector('.bundler-footer-text-final');
        if (!next) {
          if (footerTextCount) footerTextCount.classList.add('hidden');
          if (footerTextFinal) footerTextFinal.classList.remove('hidden');
        } else {
          if (footerTextCount) footerTextCount.classList.remove('hidden');
          if (footerTextFinal) footerTextFinal.classList.add('hidden');
        }

        if (!next) return '';

        const tierMins = this.$el.closest("#products-bundle").querySelectorAll(`[data-tier-min]`);
        const tierNeeded = this.$el.closest("#products-bundle").querySelectorAll(`[data-tier-needed]`);
        const tierDiscounts = this.$el.closest("#products-bundle").querySelectorAll(`[data-tier-discount]`);
        tierMins.forEach(item => {
          item.textContent = String(next.min);
        });
        tierNeeded.forEach(item => {
          item.textContent = String(next.needed);
        });
        tierDiscounts.forEach(item => {
          item.textContent = next.discount;
        });        
      },
      updateTierGauge() {
        const gauge = this.$el.closest("#products-bundle").querySelector('.bundler-gauge');
        if (!gauge) return;
        const gaugeItems = gauge.querySelectorAll('.bundler-gauge-progress-item');
        gaugeItems.forEach(item => {
          if (this.productsBundle.length >= Number(item.dataset.min)) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        });
      },
      handleProductsBundle() {
        this.$watch('productsBundle', () => {
          document.dispatchEvent(new CustomEvent(`eurus:product-bundle:productsList-changed-${sectionId}`, {
            detail: {
              productsBundle: this.productsBundle
            }
          }));
        });
      },
      addToBundle(el, productId, productUrl, hasVariant, name_edt) {
        let productsBundle = JSON.parse(JSON.stringify(this.productsBundle))
        const productName = el.closest(".x-product-bundle-data").querySelector(".product-name").textContent;
        const currentVariant =  JSON.parse(el.closest(".x-product-bundle-data").querySelector(".current-variant").textContent);
        const price =  !hasVariant && JSON.parse(el.closest(".x-product-bundle-data").querySelector(".current-price")?.textContent);
        const featured_image = currentVariant.featured_image ? currentVariant.featured_image.src : el.closest(".x-product-bundle-data").querySelector(".featured-image").textContent;
        const edtElement = el.closest(".x-product-bundle-data").querySelector(`.hidden.cart-edt-properties-${productId}`);
        let shippingMessage = '';
        if(edtElement){
          shippingMessage = edtElement.value.replace("time_to_cut_off", Alpine.store('xEstimateDelivery').noti);
        }
        const preorderElement = el.closest(".x-product-bundle-data").querySelector('.hidden.preorder-edt-properties');
        let preorderMessage = '';
        if(preorderElement){
          preorderMessage = preorderElement.value;
        }
        
        const properties = {
          ...(name_edt && shippingMessage && { [name_edt]: shippingMessage }),
          ...(preorderMessage && { Preorder: preorderMessage }),
        };

        let variantId = hasVariant ? currentVariant.id : currentVariant; 
        let newProductsBundle = [];
        let newItem = hasVariant ? { ...currentVariant, title: currentVariant.title.replaceAll("\\",""), product_id: productId, product_name: productName, productUrl: `${productUrl}?variant=${currentVariant.id}`, featured_image: featured_image, quantity: 1, "properties": properties} : { id: variantId, product_id: productId, product_name: productName, productUrl: productUrl, featured_image: featured_image, quantity: 1, price: price, "properties": properties }
        
        newProductsBundle = [...productsBundle , newItem];
        this.productsBundle = newProductsBundle;
        this.errorMessage = false;
        this.updateBundleContent(newProductsBundle)
        let bundleContentContainer = document.getElementById(`bundle-content-container-${sectionId}`);
        requestAnimationFrame(() => {
          bundleContentContainer.scrollTo({
            top: bundleContentContainer.scrollHeight,
            left: bundleContentContainer.scrollWidth,
            behavior: 'smooth'
          });
        });
      },
      async handleAddToCart(el) {
        this.loading = true;
        await Alpine.store('xCartHelper').waitForEstimateUpdate();
        window.updatingEstimate = true;

        setTimeout(() => { 
          let items = JSON.parse(JSON.stringify(this.productsBundle));
          items = items.reduce((data, product) => {
            data[product.id] ? data[product.id].quantity += product.quantity : data[product.id] = product;
            return data;
          }, {});
          
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body:  JSON.stringify({ "items": items, "sections":  Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id) })
          }).then((response) => {
            return response.json();
          }).then((response) => {

            document.dispatchEvent(new CustomEvent(`eurus:product-bundle:products-changed-${sectionId}`, {
              detail: {
                productsBundle: Object.values(items),
                el: el.closest(".product-bundler-wrapper")
              }
            }));

            if (response.status == '422') {
              const error_message = el.closest('.bundler-sticky').querySelector('.cart-warning');

              this.errorMessage = true;
              if (error_message) {
                error_message.textContent = response.description;
              }
              return;
            }
            this.errorMessage = false;
            Alpine.store('xCartHelper').getSectionsToRender().forEach((section => {
              const sectionElement = document.querySelector(section.selector);

              if (sectionElement) {
                if (response.sections[section.id])
                  sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
              }
            }));
            if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
              Alpine.store('xQuickView').show = false;
            }
            Alpine.store('xPopup').close();
            if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
              Alpine.store('xCartNoti').setItem(response); 
            } else {
              Alpine.store('xMiniCart').openCart();
              document.dispatchEvent(new CustomEvent("eurus:cart:redirect"));
            }
            Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
            document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
          })
          .catch((error) => {
            console.error('Error:', error);
          }).finally(() => {
            Alpine.store('xCartHelper').updateEstimateShippingFull();
            this.loading = false;
            this.productsBundle = [];
            this.totalPrice = 0;
            this.addToCartButton.setAttribute('disabled', 'disabled');
          })
        }, 0)
      },
      updateBundleContent(productsBundle) {
        this.updateItems(productsBundle);
        this.updateTotal(productsBundle);
        this.updateTierGauge();
        this.updateTierTexts();
      },
      removeBundle(el, indexItem) {
        let item = this.productsBundle[indexItem]
        let newProductsBundle = this.productsBundle.filter((item, index) => index != indexItem)
        this.productsBundle = newProductsBundle;
        this.updateBundleContent(newProductsBundle);

        document.dispatchEvent(new CustomEvent(`eurus:product-bundle:remove-item-${sectionId}`, {
          detail: {
            item: item,
            el: el
          }
        }));
      },
      formatWithDelimiters(number, precision, thousands, decimal) {
        precision = this.defaultOption(precision, 2);
        thousands = this.defaultOption(thousands, ',');
        decimal   = this.defaultOption(decimal, '.');
    
        if (isNaN(number) || number == null) { return 0; }
        number = (number/100.0).toFixed(precision);
    
        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';
    
        return dollars + cents;
      },
      defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
      },
      formatMoney(amount, formatString) {
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        switch(formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = this.formatWithDelimiters(amount, 2);
            break;
          case 'amount_no_decimals':
            value = this.formatWithDelimiters(amount, 0);
            break;
          case 'amount_with_comma_separator':
            value = this.formatWithDelimiters(amount, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = this.formatWithDelimiters(amount, 0, '.', ',');
            break;
        }
        return formatString.replace(placeholderRegex, value);
      },
      displayDiscountValueLabel () {
        let discount = 0;
        if (!Number.isNaN(discountValue)) {
          discount = Number(discountValue);
          if (discount > 0) {
            discount = (Number.parseFloat(discountValue)).toFixed(2) * Shopify.currency.rate * 100;
          }
          return this.formatMoney(discount, shopCurrency);
        }
      }
    }));

    Alpine.data('xProductItemBundle', (
      sectionId,
      addToBundle,
      handleSectionId,
      productUrl,
      productId,
      hasVariant,
      productOnlyAddedOnce
    ) => ({
      dataVariant: [],
      currentVariant: '',
      isSelect: false,
      productId: productId,
      productUrl: productUrl,
      initVariant() {
        let xDataVariant = this.$el.querySelector('[type="application/json"]');
        if (xDataVariant) {
          let data = JSON.parse(xDataVariant.textContent);
          data = data?.map(item => ({ disable: false, id: item.id }));
          this.dataVariant = data;
        }
        this.initEvent();
      },
      initEvent() {
        if (hasVariant) {
          document.addEventListener(`eurus:product-card-variant-select:updated:${sectionId}`, (e) => {
            this.currentVariant = e.detail.currentVariant,
            this.options = e.detail.options;
            this.renderAddToBundleButton();
            this.checkVariantSelected();
            if (this.currentVariant && this.currentVariant.id) {
              this.productUrl = productUrl + `/?variant=${this.currentVariant.id}`
            }
          });
        }

        document.addEventListener(`eurus:product-bundle:products-changed-${handleSectionId}`, (e) => {
          e.detail.productsBundle.map(item => {
            if(hasVariant && item.product_id == this.productId && this.currentVariant.available) {
              let buttonATC = document.querySelector('#x-atc-button-' + sectionId);
              if (buttonATC) buttonATC.removeAttribute('disabled');
            } else if(item.product_id == this.productId) {
              let buttonATC = document.querySelector('#x-atc-button-' + sectionId);
              if (buttonATC) buttonATC.removeAttribute('disabled');
            }
          })
          if(productOnlyAddedOnce) {
            this.setUnSelectVariant();
          }
        })

        document.addEventListener(`eurus:product-bundle:remove-item-${handleSectionId}`, (e) => {
          if (this.isSelect && e.detail.item.product_id == this.productId && hasVariant) {
            if (this.currentVariant && this.currentVariant.available) {
              let buttonATC = document.querySelector('#x-atc-button-' + sectionId);
              if (buttonATC) buttonATC.removeAttribute('disabled');
            }
            this.setUnSelectVariant(e.detail.item);
          } else if(e.detail.item.product_id == this.productId) { 
            let buttonATC = document.querySelector('#x-atc-button-' + sectionId);
            if (buttonATC) buttonATC.removeAttribute('disabled');

            if(productOnlyAddedOnce) {
              const cardProducts = document.querySelector('#bundle-product-' + e.detail.item.product_id);
              cardProducts?.classList.remove("cursor-pointer", "pointer-events-none", "opacity-70")
            }
          }
        })
      },
      setVariantSelected(el) {
        if (this.currentVariant && this.dataVariant.findIndex(item => (item.id == this.currentVariant.id && item.disable)) != -1) {
          let buttonATB = el.closest('.bundle-product').querySelector('.x-atb-button');
          buttonATB.setAttribute('disabled', 'disabled');
        }
      },
      setDisableSelectProduct(el) {
        if (productOnlyAddedOnce) {
          let newVariants = JSON.parse(JSON.stringify(this.dataVariant)).map(item => (item.id == this.currentVariant.id) ? { id: item.id, disable: true } : { id: item.id, disable: item.disable})
          this.dataVariant = newVariants;
          let buttonATB = el.closest('.bundle-product').querySelector('.x-atb-button');
          buttonATB.setAttribute('disabled', 'disabled');
        }
      },
      setUnSelectVariant(product) {
        let newVariants = "";
        if (product) {
          newVariants = JSON.parse(JSON.stringify(this.dataVariant)).map(item => (item.id == product.id) ? { id: item.id, disable: false } : { id: item.id, disable: item.disable})
        } else {
          newVariants = JSON.parse(JSON.stringify(this.dataVariant)).map(item => ({ id: item.id, disable: false }))
        }
        this.dataVariant = newVariants;
      },
      renderAddToBundleButton() {
        const buttonATB = document.getElementById('x-atc-button-' + sectionId)

        if (!buttonATB) return;

        if (this.currentVariant) {
          /// Enable add to cart button
          if (this.currentVariant.available) {
            buttonATB.removeAttribute('disabled');
            const addButtonText = buttonATB.querySelector('.x-atc-text');
            if (addButtonText) addButtonText.textContent = addToBundle;
          }
        }
      },
      checkVariantSelected() {
        const fieldset = [...document.querySelectorAll(`#variant-update-${sectionId} fieldset`)];
        if(fieldset.findIndex(item => !item.querySelector("input:checked")) == "-1") {
          this.isSelect = true;
        }
      }
    }));

    Alpine.data('xProductList', (
      sectionId,
      handleSectionId
    ) => ({
      productsList: [],
      init() {
        document.addEventListener(`eurus:product-bundle:productsList-changed-${handleSectionId}`, (e) => {
          this.productsList = e.detail.productsBundle;
        })
        document.addEventListener(`eurus:product-card-variant-select:updated:${sectionId}`, (e) => {
          this.renderAddButton();
        });
      },
      renderAddButton() {
        const currentVariant = JSON.parse(document.getElementById('current-variant-'+ sectionId).textContent);
        let variantId = typeof currentVariant === 'object' ? currentVariant?.id : currentVariant;
        const itemVariant = this.productsList.find(({ id }) => id === variantId);
        const buttonATB = document.getElementById('x-atc-button-' + sectionId);
        if (itemVariant && buttonATB) {
          setTimeout(() => {
            buttonATB.setAttribute('disabled', 'disabled');
          }, 100);
        }
      }
    }))
  });
});
}